import type { IconName } from '@storyblok/design-system'

export type StoryStatus = {
  label: string
  class: string
  icon: IconName | undefined
}

export const STORY_STATUS_OPTIONS = {
  draft: {
    label: 'Draft',
    class: 'draft',
    icon: 'story-draft',
  },
  published: {
    label: 'Published',
    class: 'published',
    icon: 'status',
  },
  published_has_changes: {
    label: 'Published & Has Changes',
    class: 'published-has-changes',
    icon: 'story-has-changes',
  },
  expired: {
    label: 'Expired',
    class: 'expired',
    icon: undefined,
  },
  scheduled: {
    label: 'Scheduled',
    class: 'scheduled',
    icon: 'story-scheduled',
  },
} as const satisfies Record<string, StoryStatus>
